import { createSelector } from 'reselect';
import { extractNodeFromConnection } from '../../utils/relay';
import { getViewer } from './viewer';
/**
 * Projects Selector
 */

const defaultList = [];
export const getProjectsFromViewer = createSelector(
  getViewer,
  (viewer) => viewer ?
    viewer.projects ?
      extractNodeFromConnection(viewer.projects)
      : defaultList
    : defaultList,
);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/relay/selectors/projects.ts